import type {NodeParameters} from "#graph/nodes/base/types"
import {z} from "zod"

export const serializedGraphNodeSchema = z.object({
    $class: z.string(),
    $parameters: z.record(z.unknown()),
    $refId: z.number(),
    $version: z.number(),
})

export type SerializedGraphNode = {
    $class: string
    $parameters: NodeParameters
    $refId: number
    $version: number
}

export type GraphNodeWithRefs = {
    refId: number
    nodeGraph: SerializedGraphNode
    referencedGraphs: Set<number>
}
